import { render, staticRenderFns } from "./legalCenter.vue?vue&type=template&id=662cb2ec&scoped=true&"
import script from "./legalCenter.vue?vue&type=script&lang=js&"
export * from "./legalCenter.vue?vue&type=script&lang=js&"
import style0 from "./legalCenter.vue?vue&type=style&index=0&id=662cb2ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662cb2ec",
  null
  
)

export default component.exports